module.exports = __webpack_public_path__ + "img/honor1.dfc40a5b.png";